<template>
  <div class="col-sm-12">
    <div class="card">
      <div class="card-body p-4">
        <!-- Single Line Filter Row -->
        <div class="filter-row-single">
          <!-- Dispatch Date Picker -->
          <div class="filter-item">
            <label class="filter-label" for="startDatePicker">Dispatch Date</label>
            <input id="startDatePicker" type="date" v-model="startDate" class="form-control filter-control" />
          </div>

          <!-- Distributor Dropdown -->
          <div class="filter-item">
            <label class="filter-label" for="distributorSelect">Distributor</label>
            <select id="distributorSelect" v-model="selectedDistributor" @change="onDistributorChange"
              class="form-select filter-control" :disabled="isDistributorLocked">
              <option value="">Select Distributor</option>
              <option v-if="!isDistributorUser" :value="ALL">All Distributors</option>
              <option v-for="distributor in distributorsList" :key="distributor.profile_id"
                :value="String(distributor.profile_id)">
                {{ distributor.name }}
              </option>
            </select>
          </div>

          <!-- Sales Rep Dropdown -->
          <div class="filter-item">
            <label class="filter-label" for="salesRepSelect">Sales Rep</label>
            <select id="salesRepSelect" v-model="selectedSalesRep" class="form-select filter-control">
              <option value="">All Sales Reps</option>
              <option v-for="rep in salesRep" :key="rep.profile_id" :value="String(rep.profile_id)">
                {{ rep.name }}
              </option>
            </select>
          </div>

          <!-- Search Button -->
          <div class="filter-item button-item">
            <button @click="performSearch" class="btn button-default btn-search-single" :disabled="loading">
              <span>Search</span>
            </button>
          </div>

          <!-- Create New Dispatch Button -->
          <div class="filter-item button-item">
            <button type="button" class="btn button-default btn-create-single" @click="navigateToNewDispatch">
              <span>Create Dispatch</span>
            </button>
          </div>
        </div>

        <!-- Loading Spinner -->
        <div v-if="loading" class="loading-spinner py-5">
          <i class="fa fa-spinner fa-spin"></i>
          <span>Loading...</span>
        </div>

        <!-- Dispatch Table Container (Shown only when not loading and data exists) -->
        <div v-else-if="formattedBootstrapList && formattedBootstrapList.length > 0" class="table-container table-responsive mt-4">
          <table class="table table-compact">
            <thead>
              <tr class="border-bottom-primary">
                <th scope="col">Dispatch No</th>
                <th scope="col">Stock Allocation</th>
                <th scope="col">Sales Rep</th>
                <th scope="col">Status</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in formattedBootstrapList" :key="index">
                <td>{{ item.dispatch_no }}</td>
                <td>{{ item.salesDistributionIds }}</td>
                <td>{{ item.salesRep }}</td>
                <td>
                  <span v-if="item.sales_rep_confirmed_label" class="badge-status badge-accepted">{{ item.sales_rep_confirmed_label }}</span>
                  <span v-else :class="getStatusBadgeClass(item)">{{ item.is_gate_pass_out_label }}</span>
                </td>
                <td>
                  <i @click="showDispatchDetails(item.id)" class="fa fa-eye action-icon" aria-hidden="true"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Modern Empty State (Shown when not loading and no data exists) -->
        <div v-else class="no-data-container mt-4">
          <div class="no-data-card">
            <div class="no-data-icon">
              <i class="fa fa-folder-open-o"></i>
            </div>
            <h5 class="no-data-title">No Dispatches Found</h5>
            <p class="no-data-text">There are no dispatch records available for the selected filters.</p>
          </div>
        </div>
    </div>
  </div>
</div>

  <!-- Dispatch Details -->
  <DispatchModal :showModal="showModal" :dispatch="dispatchDetails" :stockAllocations="stockAllocations"
    :dispatchId="dispatchId" @close="closeModal" />

</template>

<script>
import {
  griddispatch,
  fetchDispatchDetailsById,
  fetchDistributors,
  fetchSalesReps,
} from '@/services/dataService'; // Import the API functions
import { useRouter } from 'vue-router';
import DispatchModal from '../../Modal/dispatchDetails.vue';

export default {
  components: {
    DispatchModal
  },

  data() {
    const currentDate = new Date().toISOString().split('T')[0]; // Get current date in YYYY-MM-DD format
    const ALL = "__all__";
    return {
      userRole: localStorage.getItem('user_label'),
      token: localStorage.getItem('token_set'), // Get token from localStorage
      profileId: localStorage.getItem('profile_id'), // Fetch profile ID from localStorage
      startDate: currentDate, // Dispatch date for the search
      selectedDistributor: '', // Selected distributor define
      selectedSalesRep: '', // Selected sales rep define
      distributorsList: [], // Fetched Distributors List
      salesRep: [], // Fetched Sales Rep List
      org: 14, // Organization ID

      loading: false, // For showing the loading spinner
      bootstraplist: [], // To store the fetched grid data
      showPopup: false, // For showing the popup
      loadingPopup: false, // For showing the loading spinner in the popup
      dispatchDetails: {}, // To store the dispatch details
      stockAllocations: {}, // To store the stock allocations
      showModal: false,
      dispatchId: 0,

      ALL,
      isDistributorLocked: false,
      roleKey: "OTHER",

    };
  },

  setup() {
    const router = useRouter();
    const navigateToNewDispatch = () => {
      router.push('/new-dispatch');
    };
    return { navigateToNewDispatch };
  },

  mounted() {
    this.fetchDistributors(); //Fetch distributors list
  },

  // computed: {
  //   formattedBootstrapList() {
  //     return this.bootstraplist.map(item => ({
  //       ...item,
  //       is_gate_pass_out: item.is_active === '0' ? 'status-yes' : 'status-no',
  //       is_gate_pass_out_label: item.is_active === '0' ? 'Canceled' : (item.is_gate_pass_out === '1' ? 'GatePass[Out]' : 'Pending'),
  //       sales_rep_confirmed_label: item.sales_rep_confirmed === '1' ? 'DSR Accepted' : ''
  //     }));
  //   }
  // },

  computed: {
    isDistributorUser() {
      const u = String(this.userRole || "").toUpperCase().trim();
      return (u === "DISTRIBUTOR" || u.startsWith("DISTRIBUTOR") || u === "DIS" || u.startsWith("DIS_"));
    },

    formattedBootstrapList() {
      return this.bootstraplist.map(item => ({
        ...item,
        is_gate_pass_out: item.is_active === '0' ? 'status-yes' : 'status-no',
        is_gate_pass_out_label: item.is_active === '0' ? 'Canceled' : (item.is_gate_pass_out === '1' ? 'GatePass[Out]' : 'Pending'),
        sales_rep_confirmed_label: item.sales_rep_confirmed === '1' ? 'DSR Accepted' : ''
      }));
    }
  },


  watch: {
    showModal(newVal) {
      if (newVal) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    }
  },

  methods: {
    // Fetch list of Distributors
    // async fetchDistributors() {
    //   this.loading = true;
    //   try {
    //     const response = await fetchDistributors(this.profileId, this.token);
    //     this.distributorsList = response.data.data; // Add 'All' option
    //     this.selectedDistributor = ''; // Set 'All' option as default
    //   } catch (error) {
    //     console.error('Error fetching sales types:', error);
    //   } finally {
    //     this.loading = false;
    //   }
    // },


    async fetchDistributors() {
      this.loading = true;

      try {
        const response = await fetchDistributors(this.profileId, this.token);
        let list = response?.data?.data || [];

        // reset first
        this.distributorsList = [];
        this.selectedDistributor = "";
        this.isDistributorLocked = false;

        // ✅ Distributor login: auto fill & lock only own distributor
        if (this.isDistributorUser && this.profileId) {
          const mine = list.find(d => Number(d.profile_id) === Number(this.profileId));
          if (mine) {
            this.distributorsList = [mine];
            this.selectedDistributor = String(mine.profile_id);
            this.isDistributorLocked = true;

            // programmatic set -> manually load reps
            await this.fetchSalesRepresentatives();
            return;
          }
        }



        // ✅ Non-distributor: show full list, user must pick (or ALL)
        this.distributorsList = list;

      } catch (error) {
        console.error("Error fetching distributors:", error);
      } finally {
        this.loading = false;
      }
    },


    async onDistributorChange() {
      // reset reps when distributor changes
      this.selectedSalesRep = "";
      this.salesRep = [];

      // No selection
      if (!this.selectedDistributor) return;

      // ✅ If ALL distributors -> do not call reps API with ALL
      if (this.selectedDistributor === this.ALL) {
        // show "All Sales Reps" only (empty list + default option works)
        this.salesRep = [];
        this.selectedSalesRep = "";
        return;
      }

      // Normal distributor -> load reps
      await this.fetchSalesRepresentatives();
    },



    // Fetch list of Sales Reps
    // async fetchSalesRepresentatives() {
    //   this.loading = true;
    //   try {
    //     const response = await fetchSalesReps(this.profileId, this.selectedDistributor, this.token);
    //     this.salesRep = [{ profile_id: '', name: 'All Sales Reps' }, ...response.data.data]; // Add 'All' option
    //     this.selectedSalesRep = ''; // Set 'All' option as default
    //   } catch (error) {
    //     console.error('Error fetching sales reps:', error);
    //   } finally {
    //     this.loading = false;
    //   }
    // },


    async fetchSalesRepresentatives() {
      // block invalid distributor selections
      if (!this.selectedDistributor || this.selectedDistributor === this.ALL) {
        this.salesRep = [];
        this.selectedSalesRep = "";
        return;
      }

      this.loading = true;
      try {
        const response = await fetchSalesReps(this.profileId, this.selectedDistributor, this.token);

        const reps = response?.data?.data || [];
        this.salesRep = reps.map(r => ({
          profile_id: String(r.profile_id),
          name: r.name
        }));

        this.selectedSalesRep = ""; // default "All Sales Reps"
      } catch (error) {
        console.error("Error fetching sales reps:", error);
      } finally {
        this.loading = false;
      }
    },


    // Perform the search with selected Sales Rep and Dispatch Date
    async performSearch() {

      if (!this.startDate) {
        alert('Please select a dispatch date.');
        return;
      }
      if (!this.selectedDistributor) {
        alert('Please select a distributor.');
        return;
      }

      if (this.isDistributorUser && this.selectedDistributor === this.ALL) {
        alert("Please select a distributor.");
        return;
      }
      // Start loading
      this.loading = true;
      this.bootstraplist = [];

      // Prepare the payload for the API request
      // const payload = {
      //   rep_id: this.selectedSalesRep, // Sales Rep ID
      //   distributor_id: this.selectedDistributor,
      //   dispatch_date: this.startDate,  // Dispatch Date
      //   created_by: this.profileId,     // Created by ID
      // };

      const payload = {
        rep_id: this.selectedSalesRep || null,
        distributor_id: (this.selectedDistributor === this.ALL) ? null : this.selectedDistributor,
        dispatch_date: this.startDate,
        created_by: this.profileId,
      };


      console.log("Payload:", payload);
      // console.log("selectedDistributor:", this.selectedDistributor);
      // console.log("payload.distributor_id:", (this.selectedDistributor === this.ALL) ? null : this.selectedDistributor);

      try {
        // Call the API to fetch the dispatch data
        const response = await griddispatch(payload, this.token);

        // Handle the API response and update the grid data
        if (response.data.status === 'success') {
          this.bootstraplist = response.data.data.map(dispatch => ({
            dispatch_no: dispatch.dispatch_no,
            salesDistributionIds: dispatch.stock_allocations.join(', '),
            salesRep: `${dispatch.rep_fname} ${dispatch.rep_lname}`,
            vehicleNo: dispatch.vehicle_no,
            driver: dispatch.driver_name,
            is_gate_pass_out: dispatch.is_gate_pass_out,
            sales_rep_confirmed: dispatch.sales_rep_confirmed,
            id: dispatch.id,
            is_active: dispatch.is_active
          }));
          console.log('Mapped bootstraplist:', this.bootstraplist);
        } else {
          this.bootstraplist = [];
        }
      } catch (error) {
        console.error('Error performing search:', error);
      } finally {
        // Stop loading
        this.loading = false;
      }
    },

    // Navigate to details view
    viewDetails(id) {
      this.$router.push({ name: 'distpachedit', params: { id } });
    },

    async showDispatchDetails(id) {
      this.loading = true
      this.selectedInvoice = "";
      try {
        const response = await fetchDispatchDetailsById(id, this.token);
        this.dispatchDetails = response.data.data.dispatch;
        this.stockAllocations = response.data.data.stock_allocations;
        this.showModal = true;
        this.dispatchId = id;
        console.log("dispatchId:", this.dispatchId, "Type:", typeof this.dispatchId);
      } catch (error) {
        console.error('Error fetchiing dispatch details:', error);
      } finally {
        this.loading = false
      }
    },

    closeModal() {
      this.showModal = false;
    },

    getStatusBadgeClass(item) {
      if (item.is_active === '0') {
        return 'badge-status badge-canceled';
      }
      if (item.is_gate_pass_out === '1') {
        return 'badge-status badge-dispatched';
      }
      return 'badge-status badge-pending';
    },

  },
};
</script>

<style scoped lang="scss">
/* Single Line Filter Row Layout */
.filter-row-single {
  display: flex;
  align-items: flex-end;
  flex-wrap: nowrap;
  gap: 16px;
  width: 100%;
}

.filter-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
  min-width: 0;
}

.filter-item.button-item {
  flex: 0 0 auto;
}

.filter-label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #334155;
  margin-bottom: 0;
  white-space: nowrap;
}

.filter-control {
  height: 42px;
  border-radius: 6px;
  border: 1px solid #cbd5e1;
  font-size: 0.9rem;
  color: #1e293b;
  padding: 0 12px;
  width: 100%;
  background-color: #ffffff;
  transition: all 0.2s ease;
  box-sizing: border-box;
}

.filter-control:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.15);
  outline: none;
}

.btn-search-single {
  height: 42px;
  padding: 0 20px;
  background-color: #007bff;
  color: #ffffff;
  font-weight: 600;
  font-size: 0.9rem;
  border-radius: 6px;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  box-sizing: border-box;
}

.btn-search-single:hover {
  background-color: #0056b3;
  box-shadow: 0 4px 6px -1px rgba(0, 123, 255, 0.2);
}

.btn-create-single {
  height: 42px;
  padding: 0 20px;
  font-weight: 600;
  font-size: 0.9rem;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  box-sizing: border-box;
}

.button-default {
  background-color: #007bff !important;
  color: #ffffff !important;
  border: none !important;
}

.button-default:hover {
  background-color: #0056b3 !important;
  box-shadow: 0 4px 6px -1px rgba(0, 123, 255, 0.2);
}

.loading-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 1.1rem;
  font-weight: 500;
  text-align: center;
  color: #007bff;
  padding: 48px 0;
  width: 100%;
}

.fa-edit {
  cursor: pointer;
  transition: color 0.3s, transform 0.3s;
  /* Smooth transition for color and transform */
}

/* Hover effect for the "edit" icon */
.fa-edit:hover {
  color: #0056b3;
  /* Darker shade on hover */
  transform: scale(1.2);
  /* Slightly enlarge the icon on hover */
}

.fa-eye {
  cursor: pointer;
  transition: color 0.3s, transform 0.3s;
  margin-left: 5px;
}

.fa-eye:hover {
  color: #0056b3;
  transform: scale(1.2);
}

.fa-eye:active {
  transform: scale(1.1);
}

.action-icon {
  margin-right: 10px;
}

.status-yes {
  background-color: green;
  color: #fff;
  border-radius: 4px;
  padding: 5px 10px;
}

.status-no {
  background-color: red;
  color: #fff;
  border-radius: 4px;
  padding: 5px 10px;
}

.status-dsr {
  background-color: blue;
  color: #fff;
  border-radius: 4px;
  padding: 5px 10px;
  margin-top: 5px;
}

.text-center {
  text-align: center;
}

/* Make the sales rep dropdown scrollable */
.sales-rep-select {
  max-height: 200px;
  /* Adjust the height as needed */
  overflow-y: auto;
  /* Enable vertical scrolling */
}

/* Popup modal */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.popup-content {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  width: 400px;
  max-width: 90%;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #000;
  transition: color 0.3s;
}

.popup-content h3 {
  margin-top: 0;
}

.popup-content ul {
  padding-left: 20px;
}

.popup-content ul li {
  margin-bottom: 10px;
}

.popup-table {
  max-height: 300px;
  /* Adjust the height as needed */
  overflow-y: auto;
  /* Enable vertical scrolling */
}

/* Table Container with Fixed Max Height & Scrolling */
.table-container {
  max-height: 520px;
  overflow-y: auto;
  overflow-x: auto;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

/* Compact Table Styling */
.table-compact {
  width: 100%;
  margin-bottom: 0;
  border-collapse: separate;
  border-spacing: 0;

  th {
    padding: 10px 14px;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #4a5568;
    background-color: #f7fafc;
    border-bottom: 2px solid #e2e8f0;
    white-space: nowrap;
    position: sticky;
    top: 0;
    z-index: 5;
  }

  td {
    padding: 9px 14px;
    font-size: 13px;
    color: #2d3748;
    vertical-align: middle;
    white-space: nowrap;
    border-bottom: 1px solid #edf2f7;
  }

  tbody tr:hover {
    background-color: #f8fafc;
  }

  tbody tr:last-child td {
    border-bottom: none;
  }
}

/* Badge Styling - Small & Uniform Dimensions */
.badge-status {
  display: inline-block;
  min-width: 105px;
  width: 105px;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 600;
  text-align: center;
  border-radius: 4px;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  color: #ffffff;
}

.badge-dispatched,
.badge-accepted {
  background-color: #069e27;
  border: 1px solid #058521;
}

.badge-pending,
.badge-canceled {
  background-color: #d32f2f;
  border: 1px solid #b71c1c;
}

/* Modern Empty State Styling */
.no-data-container {
  width: 100%;
}

.no-data-card {
  text-align: center;
  background: #f8fafc;
  border: 1px dashed #cbd5e0;
  border-radius: 8px;
  padding: 50px 25px;
  width: 100%;
}

.no-data-icon {
  font-size: 42px;
  color: #a0aec0;
  margin-bottom: 12px;
}

.no-data-title {
  font-size: 16px;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 6px;
}

.no-data-text {
  font-size: 13px;
  color: #718096;
  margin: 0;
}
</style>